import * as React from 'react';
import BasicSchedule, { IBasicSchedule } from './basicSchedule';
import CronSchedule from './cronSchedule';
import { ScheduleTypes } from '../scheduleTypes';

export interface ScheduleI extends Partial<IBasicSchedule> {
  type?: string;
  cron_expression?: string;
}

export interface ScheduleProps {
  scheduleType?: string;
  onRunSettingsChange: (value: ScheduleI) => void;
  setInvalid: (isInvalid: boolean) => void;
  value?: ScheduleI;
}

const Schedules = (props: ScheduleProps) => {
  const { scheduleType, value, onRunSettingsChange, setInvalid } = props;

  let runSettings;

  switch (scheduleType) {
    case ScheduleTypes.Basic:
      runSettings = <BasicSchedule value={value} onChange={onRunSettingsChange} />;
      break;
    case ScheduleTypes.Cron:
      runSettings = (
        <CronSchedule
          expression={value?.cron_expression}
          onChange={onRunSettingsChange}
          setInvalid={setInvalid}
        />
      );
      break;
    default:
      runSettings = null;
  }

  return runSettings;
};

export default Schedules;
